import React from "react";
import {FormattedMessage} from "react-intl";

export default (props) => {
  return (
    <h1 className="page-title">
      <FormattedMessage id="accessibility.title" defaultMessage="Accessibility"/>
    </h1>
  );
}
